<script>
import { axiosGetPost } from '@router/axiosGetPost'
import AddSurchargeList from '@components/contract/add-surcharge-list'
import Multiselect from 'vue-multiselect'

export default {
  name: 'SurchargeManager',
  props: {
    nameVariation: { type: String, default: null },
  },
  components: {
    AddSurchargeList,
    Multiselect,
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      },
    },
  },
  data() {
    return {
      loading: false,
      surcharge: null,
      surchargeList: [],
      surchargeVariation: this.nameVariation,
      surchargeVariations: [],
      addNewBool: false,
    }
  },
  methods: {
    searchSurcharge(surchargeName) {
      axiosGetPost('post', '/cargofive/search_surcharge', {
        name: surchargeName,
      }, "Search Surcharger").then((response) => {
        this.surchargeList = response.list
      })
    },
    getVariations() {
      this.loading = true
      axiosGetPost('post', '/cargofive/list_surcharge_variations', {
        surcharge_id: this.surcharge.id,
      }, "Get variation Surcharger").then((response) => {
        this.surchargeVariations = response.list.map((s, i) => ({
          index: i,
          name: s,
          editing: false,
        }))
        this.loading = false
      })
    },
    addVariation(variation_name) {
      this.loading = true
      axiosGetPost('post', '/cargofive/add_surcharge_variation', {
        surcharge_id: this.surcharge.id,
        variation: variation_name,
      }, "Add variation Surcharger").then((response) => {
        this.surchargeVariations = response.list.map((s, i) => ({
          index: i,
          name: s,
          editing: false,
        }))
        this.loading = false
      })
    },
    editVariation(variation_name, variation_id) {
      this.loading = true
      axiosGetPost('post', '/cargofive/edit_surcharge_variation', {
        surcharge_id: this.surcharge.id,
        variation: variation_name,
        variation_id: variation_id,
      }, "Edit variation surcharger").then((response) => {
        this.surchargeVariations = response.list.map((s, i) => ({
          index: i,
          name: s,
          editing: false,
        }))
        this.loading = false
      })
    },
    deleteVariation(variation_name) {
      this.loading = true
      axiosGetPost('post', '/cargofive/delete_surcharge_variation', {
        surcharge_id: this.surcharge.id,
        variation: variation_name,
      }, "Drop variation surcharger").then((response) => {
        this.surchargeVariations = response.list.map((s, i) => ({
          index: i,
          name: s,
          editing: false,
        }))
        this.loading = false
      })
    },
    addNew() {
      this.addNewBool = !this.addNewBool
      this.surcharge = null
      this.surchargeList = []
      this.surchargeVariations = []
    },
  },
}
</script>


<template>
  <div class="row">
    <div class="col-12">
      <div class="row form-group">
        <div class="col-10">
          <multiselect
            v-model="surcharge"
            id="ajax"
            label="name"
            track-by="fullData"
            placeholder="Search surcharge"
            open-direction="bottom"
            :multiple="false"
            :searchable="true"
            :loading="loading"
            :internal-search="false"
            :disabled="addNewBool"
            :reduce="(options) => options.id"
            :options="surchargeList"
            @search-change="searchSurcharge"
            @input="getVariations"
          ></multiselect>
        </div>
        <div class="col-2">
          <button
            v-if="addNewBool === false"
            class="btn btn-sm my-1 btn-outline-secondary"
            title="Add New"
            @click="addNew"
          >
            Add New <i class="uil uil-plus"></i>
          </button>
          <button
            v-else
            class="btn btn-sm my-1 btn-outline-danger"
            title="Add New"
            @click="addNew"
          >
            &nbsp;&nbsp;Cancel <i class="uil uil-multiply"></i>&nbsp;&nbsp;
          </button>
        </div>
      </div>
    </div>
    <div v-if="loading && addNewBool === false" class="col-12">
      <div
        class="row align-items-center justify-content-center"
        style="height: 350px"
      >
        <div class="col-12 col-md-8 text-center">
          <b-spinner
            label="Loading..."
            variant="secondary"
            class="ml-3"
          ></b-spinner>
        </div>
      </div>
    </div>
    <div
      v-else-if="surchargeVariations.length > 0 && addNewBool === false"
      class="col-12"
    >
      <div class="row" style="height: 300px; overflow-y: scroll">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-striped mb-0">
              <tbody>
                <tr v-for="h in surchargeVariations" :key="h.index">
                  <th scope="row">{{ h.index }}</th>
                  <td>
                    <input
                      v-if="h.editing"
                      v-model="h.name"
                      v-focus
                      class="w-100"
                      @keyup.enter="editVariation(h.name, h.index)"
                      @blur="editVariation(h.name, h.index)"
                    />
                    <p v-else>
                      {{ h.name }}
                    </p>
                  </td>
                  <td style="text-align: end">
                    <button
                      class="btn btn-sm btn-info ml-2"
                      @click="h.editing = !h.editing"
                    >
                      <i class="uil uil-edit"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-danger ml-2"
                      @click="deleteVariation(h.name)"
                    >
                      <i class="uil uil-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <input
            v-model="surchargeVariation"
            type="text"
            class="form-control"
            placeholder="new variation"
          />
        </div>
        <div class="col-12 col-md-3">
          <button
            class="btn btn-success w-100"
            @click="addVariation(surchargeVariation)"
          >
            Add
          </button>
        </div>
      </div>
    </div>
    <div v-else-if="addNewBool === true" class="col-12">
      <AddSurchargeList @update_view="addNew" />
    </div>
    <div v-else class="col-12">
      <div
        class="row align-items-center justify-content-center"
        style="height: 350px"
      >
        <div class="col-12 col-md-8 text-center">
          <feather type="anchor" class="icon-xxl icon-dual-info"></feather>
          <h6 class="text-muted">Select a surcharged</h6>
        </div>
      </div>
    </div>
  </div>
</template>